module.exports = __webpack_public_path__ + "media/music/jazzy_bass_4-54c4cef3.mp3";